import { PatientAddress } from '@types';

export function formatAddress(address?: PatientAddress | string) {
  if (typeof address === 'string') return address;
  return address
    ? `${address.streetAddress1}${address.streetAddress2 ? ` ${address.streetAddress2}` : ''}, ${
        address.city
      }, ${address.stateCode} ${address.zip}`
    : '';
}
